module.exports = __webpack_public_path__ + "img/pack-items.51ffd0d1.svg";